import { useQuery } from "react-query";

import { getPoints } from "../utils/api";

const useBranches = () => {
  const { data, isLoading, isError, refetch } = useQuery(
    "branches",
    getPoints,
    { refetchOnWindowFocus: false }
  );

  return {
    data: data ?? [],
    isError,
    isLoading,
    refetch,
  };
};

export default useBranches;
